 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import A1_TITLE from '@/components/01_Title'
 import UNTITLED137 from '@/components/Untitled-1-37'
 import UNTITLED138 from '@/components/Untitled-1-38'
 import UNTITLED139 from '@/components/Untitled-1-39'
 import UNTITLED140 from '@/components/Untitled-1-40'
 import UNTITLED141 from '@/components/Untitled-1-41'
 import UNTITLED142 from '@/components/Untitled-1-42'
 import UNTITLED143 from '@/components/Untitled-1-43'
 import UNTITLED144 from '@/components/Untitled-1-44'
 import UNTITLED145 from '@/components/Untitled-1-45'
 import UNTITLED146 from '@/components/Untitled-1-46'
 import UNTITLED147 from '@/components/Untitled-1-47'
 import UNTITLED148 from '@/components/Untitled-1-48'
 import UNTITLED149 from '@/components/Untitled-1-49'
 import UNTITLED150 from '@/components/Untitled-1-50'
 import UNTITLED151 from '@/components/Untitled-1-51'
 import UNTITLED152 from '@/components/Untitled-1-52'
 import UNTITLED153 from '@/components/Untitled-1-53'
 import UNTITLED154 from '@/components/Untitled-1-54'
 import UNTITLED155 from '@/components/Untitled-1-55'
 import UNTITLED156 from '@/components/Untitled-1-56'
 import UNTITLED157 from '@/components/Untitled-1-57'
 import UNTITLED158 from '@/components/Untitled-1-58'
 import UNTITLED159 from '@/components/Untitled-1-59'
 import UNTITLED160 from '@/components/Untitled-1-60'
 import UNTITLED161 from '@/components/Untitled-1-61'
 import UNTITLED162 from '@/components/Untitled-1-62'
 import UNTITLED163 from '@/components/Untitled-1-63'
 import UNTITLED164 from '@/components/Untitled-1-64'
 import UNTITLED165 from '@/components/Untitled-1-65'
 import UNTITLED166 from '@/components/Untitled-1-66'
 import UNTITLED167 from '@/components/Untitled-1-67'
 import UNTITLED168 from '@/components/Untitled-1-68'
 import UNTITLED169 from '@/components/Untitled-1-69'
 import UNTITLED170 from '@/components/Untitled-1-70'
 import UNTITLED171 from '@/components/Untitled-1-71'
 import UNTITLED172 from '@/components/Untitled-1-72'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ENDMATTER2 from '@/components/endmatter2'
 import ENDMATTER3 from '@/components/endmatter3'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/01_Title",
 			"name" : "01_Title",
 			"component" : A1_TITLE
 		},
 		{
 			"path" : "/Untitled-1-37",
 			"name" : "Untitled-1-37",
 			"component" : UNTITLED137
 		},
 		{
 			"path" : "/Untitled-1-38",
 			"name" : "Untitled-1-38",
 			"component" : UNTITLED138
 		},
 		{
 			"path" : "/Untitled-1-39",
 			"name" : "Untitled-1-39",
 			"component" : UNTITLED139
 		},
 		{
 			"path" : "/Untitled-1-40",
 			"name" : "Untitled-1-40",
 			"component" : UNTITLED140
 		},
 		{
 			"path" : "/Untitled-1-41",
 			"name" : "Untitled-1-41",
 			"component" : UNTITLED141
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js